/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Checkout_SuccessInputs */

const en_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment successful! Your plan has been activated.`)
};

const de_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung erfolgreich! Dein Plan wurde aktiviert.`)
};

const fr_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement réussi ! Ton plan a été activé.`)
};

const es_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago exitoso. Tu plan ha sido activado.`)
};

const it_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento riuscito! Il tuo piano è stato attivato.`)
};

const nl_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling geslaagd! Je plan is geactiveerd.`)
};

const pl_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność zakończona sukcesem! Twój plan został aktywowany.`)
};

const fi_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksu onnistui! Suunnitelmasi on aktivoitu.`)
};

const da_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling gennemført! Din plan er nu aktiveret.`)
};

const sv_pricing_checkout_success = /** @type {(inputs: Pricing_Checkout_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalningen lyckades! Din plan har aktiverats.`)
};

/**
* | output |
* | --- |
* | "Payment successful! Your plan has been activated." |
*
* @param {Pricing_Checkout_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_checkout_success = /** @type {((inputs?: Pricing_Checkout_SuccessInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Checkout_SuccessInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_checkout_success(inputs)
	if (locale === "fr") return fr_pricing_checkout_success(inputs)
	if (locale === "es") return es_pricing_checkout_success(inputs)
	if (locale === "it") return it_pricing_checkout_success(inputs)
	if (locale === "nl") return nl_pricing_checkout_success(inputs)
	if (locale === "pl") return pl_pricing_checkout_success(inputs)
	if (locale === "fi") return fi_pricing_checkout_success(inputs)
	if (locale === "da") return da_pricing_checkout_success(inputs)
	if (locale === "sv") return sv_pricing_checkout_success(inputs)
	return en_pricing_checkout_success(inputs)
});